module.exports = __webpack_public_path__ + "img/grid-bg.1c67e890.svg";